import { IAppConfiguration } from './IAppConfiguration';

export default {
  logrocketKey: undefined,
  tenantName : 'aptormls',
  aptorApi: 'https://aptormls.b2clogin.com/aptormls.onmicrosoft.com/B2C_1A_signup_signin',
  clientId: 'b482f340-70bf-48bf-9b22-c652143291fe',
  redirectUrl:'http://localhost:3000/',
  policyName: 'B2C_1A_signup_signin',
  inivtePolicy: 'B2C_1A_signup_invitation',
  forgotPasswordPolicy : 'B2C_1A_passwordreset',
  redirectLogoutUrl:'http://localhost:3000/',
  enableImpersonation: true,
  knownAuthority: 'https://aptormls.b2clogin.com',
  mlsApiUrl:'https://localhost:7099/api/',
  ftpurl:"test-mls.aptoronline.com/",
  scopes: ['https://aptormls.onmicrosoft.com/f5310abc-c1a3-436d-9046-aa3698bb3bf7/tasks.read','https://aptormls.onmicrosoft.com/f5310abc-c1a3-436d-9046-aa3698bb3bf7/tasks.write']
} as IAppConfiguration;
